module.exports = __webpack_public_path__ + "media/images/common/cart_bottom_bg-dd72f7d510540ef011c6cb0de7daeca3.png";